import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/billing-systems/profile/loading';

export const Route = createFileRoute('/_private/settings/billing-systems/$id')({
  pendingComponent: Loading,
});
